import PlaceholderPage from '../components/PlaceholderPage';

export default function SettingsPage() {
  return <PlaceholderPage title="Settings" description="Platform settings arrive in a later phase." />;
}
